
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"100","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"fill":"#F5F5F5","cx":"50","cy":"50","r":"50"}}),_c('path',{attrs:{"d":"M86.7 55.16L66.43 68.23l-.01-.01a7.63 7.63 0 00-8.23-1.7L46.8 48.66l25.32-16.34a2.52 2.52 0 013.5.77l11.84 18.56a2.56 2.56 0 01-.77 3.51z","fill":"#F90"}}),_c('path',{attrs:{"d":"M14.56 32.57c.09.14.28.18.42.09l7.21-4.68a.3.3 0 00.09-.42l-1.65-2.6a.3.3 0 00-.2-.14.3.3 0 00-.22.04L13 29.54a.3.3 0 00-.14.19c-.01.08 0 .16.04.23l1.66 2.6z","fill":"#535353"}}),_c('path',{attrs:{"d":"M31.24 25.2l26.62 41.3c-1 .4-1.9.99-2.64 1.74L28.6 26.97a2.87 2.87 0 00-3.99-.92l-2.16 1.37-1.7-2.65 2.15-1.38a6.05 6.05 0 018.33 1.81zM84.7 58.1c0 1.09-.54 2.1-1.44 2.68l-15 9.82a7.64 7.64 0 00-1.72-2.65l17.67-11.56c.32.51.49 1.1.49 1.71z","fill":"#C9C9C9"}}),_c('path',{attrs:{"d":"M67.6 71.4a7.34 7.34 0 00-1.67-2.55l-.02-.01a7.5 7.5 0 00-8.05-1.66l-.02.01a7.52 7.52 0 00-3.17 11.53A7.5 7.5 0 0067.6 71.4zm-5.48 5.08a2.77 2.77 0 11-3-4.66 2.77 2.77 0 013 4.66z","fill":"#535353"}}),_c('path',{attrs:{"fill":"#FFB048","d":"M66.54 35.84L46.9 48.5 36.54 32.27l.02-.01L56.8 19.28l3.02 4.6-.63.45z"}}),_c('path',{attrs:{"fill":"#F90","d":"M59.44 24.81l1.22 1.84-19.73 12.37-1.23-1.83z"}}),_c('path',{attrs:{"fill":"#F5F5F5","d":"M53.12 32.87l-3.45 2.2-5.23-8.05 3.44-2.2z"}})])
          )
        }
      }
    